import CheckboxInput, { CheckboxInputProps } from './checkbox-input';
import DateInputInput, { DateInputInputProps } from './date-input';
import MultiSelectInput, { MultiSelectInputProps } from './multiselect-input';
import NumberInput, { NumberInputProps } from './number-input';
import PasswordInput, { PasswordInputProps } from './password-input';
import RichTextInput, { RichTextInputProps } from './rich-text-input';
import SelectInput, { SelectInputProps } from './select-input';
import SwitchInput, { SwitchInputProps } from './switch-input';
import TagsInput, { TagsInputProps } from './tags-input';
import TextInput, { TextInputProps } from './text-input';
import TextareaInput, { TextareaInputProps } from './textarea-input';
import TimeInput, { TimeInputProps } from './time-input';

export default function Input(
  props:
    | TextInputProps
    | NumberInputProps
    | CheckboxInputProps
    | PasswordInputProps
    | TagsInputProps
    | TextareaInputProps
    | MultiSelectInputProps
    | SelectInputProps
    | DateInputInputProps
    | TimeInputProps
    | SwitchInputProps
    | RichTextInputProps,
) {
  switch (props.type) {
    case 'text':
      return <TextInput {...props} />;
    case 'number':
      return <NumberInput {...props} />;
    case 'checkbox':
      return <CheckboxInput {...props} />;
    case 'password':
      return <PasswordInput {...props} />;
    case 'switch':
      return <SwitchInput {...props} />;
    case 'tags':
      return <TagsInput {...props} />;
    case 'textarea':
      return <TextareaInput {...props} />;
    case 'multi-select':
      return <MultiSelectInput {...props} />;
    case 'select':
      return <SelectInput {...props} />;
    case 'date':
    case 'date-time':
      return <DateInputInput {...props} />;
    case 'time':
      return <TimeInput {...props} />;
    case 'editor':
      return <RichTextInput {...props} />;
  }
}
